module.exports = __webpack_public_path__ + "static/media/SF-4-A.5af526e5.mp3";